// This is where React is bootstrapped to Angular.
// Or in other words, this is where React is translated in a way so that AngularJS understands it.
// When migration is being done you need to add your react component in this index file in order to use it properly.
// This is also where you inject angular services and similar to your React props.

import angular from "angular";
import { react2angular } from "react2angular";

import { ReactContainer } from "./Boostrapping/ReactContainer";

import {
    MainDashboard,
    AlarmCentrals,
    Partners,
    PartnerDetails,
    Teams,
    Equipment,
    AlarmCentralDetails,
    EquipmentTypes,
    Manufacturers,
    Companies,
    CompanyDetails,
    UserProfileDetailsDataContainer,
} from "./Components";

angular
    .module("irReact", ["mmServices", "mmRepositories"])
    .component(
        "mainDashboard",
        react2angular(ReactContainer(MainDashboard), undefined, [
            "irUsersRepository",
            "mmCompaniesRepository",
            "mmIssuesRepository",
            "mmSitesRepository",
            "mmSiteScheduleExceptionsRepository",
            "mmTeamsRepository",
            "mmSiteVideoStreamsRepository",
            "mmPartnersRepository",
        ]),
    );

angular
    .module("irReact")
    .component(
        "alarmCentrals",
        react2angular(ReactContainer(AlarmCentrals), undefined, [
            "mmAlarmCentralsRepository",
            "mmPartnersRepository",
            "irPageService",
            "mmModalService",
        ]),
    )
    .component(
        "userProfileDetailsDataContainer",
        react2angular(ReactContainer(UserProfileDetailsDataContainer), undefined, [
            "mmProfileService",
            "irLocalesRepository",
            "mmTimeZonesRepository",
            "mmAccountRepository",
        ]),
    )
    .component(
        "partners",
        react2angular(ReactContainer(Partners), undefined, ["mmPartnersRepository", "irPageService", "mmModalService"]),
    )
    .component(
        "partnerdetails",
        react2angular(ReactContainer(PartnerDetails), undefined, [
            "mmPartnersRepository",
            "mmPartnerUsersRepository",
            "irRolesRepository",
            "mmModalService",
            "irPageService",
            "$state",
            "mmTimeZonesRepository",
            "irCountriesRepository",
            "irLocalesRepository",
        ]),
    )
    .component(
        "teams",
        react2angular(ReactContainer(Teams), undefined, ["mmTeamsRepository", "irPageService", "mmModalService"]),
    )
    .component(
        "equipment",
        react2angular(ReactContainer(Equipment), undefined, ["mmEquipmentRepository", "irPageService"]),
    )
    .component(
        "equipmentTypesList",
        react2angular(ReactContainer(EquipmentTypes), undefined, [
            "mmEquipmentTypeRepository",
            "irManufacturersRepository",
            "irPageService",
        ]),
    )
    .component(
        "alarmCentralDetails",
        react2angular(ReactContainer(AlarmCentralDetails), undefined, [
            "$state",
            "mmAlarmCentralsRepository",
            "mmModalService",
        ]),
    )
    .component(
        "manufacturers",
        react2angular(ReactContainer(Manufacturers), undefined, ["irManufacturersRepository", "irPageService"]),
    )
    .component(
        "companies",
        react2angular(ReactContainer(Companies), undefined, ["mmCompaniesRepository", "mmPartnersRepository"]),
    )
    .component(
        "companydetails",
        react2angular(ReactContainer(CompanyDetails), undefined, ["$state", "mmCompaniesRepository"]),
    );
